// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/tdl-home-middle.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  overflow: scroll;
}
.overlay {
  /* height: 100%; */
  height: 10000px;
  background-color: #000;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
  opacity: 0.8;
  background-color: rgb(35, 35, 35);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  overflow: scroll;
}

.viewport {
  height: 10000px;
  overflow: scroll;
  position: absolute;
  top: 25vh;
  left: 2vw;
}

.home-buttons-container {
  margin-top: 600px;
  margin-left: 25vw;
}

.overlay-middle {
  top: 120px;
  /* height: 100vh; */
  padding-top: 90px;
  padding-bottom: 90px;
  background-color: #ffffff;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  word-wrap: break-word;
  display: block;
  box-sizing: border-box;
}

.home-top {
  height: 100%;
  padding-top: 80px;
  padding-bottom: 0px;
}

@media only screen and (max-width: 800px) {
  .overlay {
    /* height: 600px; */
  }
  .home-top {
    margin-top: 120px;
    /* height: 350px; */
    background-position: top 150px;
  }
  .home-buttons-container {
    margin-top: 350px;
    margin-left: 60px;
  }
  .home-main-text {
    font-size: 26px;
  }
  .welcome-text {
    font-size: 26px;
  }
  .welcome-sub-text-1 {
    font-size: 26px;
  }
}

.home-main-text {
  padding: 10px;
  margin-top: 45px;
  margin-left: 25vw;
}

.welcome-text {
  text-align: left;
  color: white;
  font-size: 100px;
  text-shadow:
    0 0 3px #5a7887,
    0 0 5px #63a8be;
}

.welcome-sub-text-1 {
  color: white;
  font-size: 45px;
  text-shadow:
    0 0 3px #5a7887,
    0 0 5px #63a8be;
  /* border: #000; */
}

.button-blue {
  text-shadow:
    0 0 3px #5a7887,
    0 0 5px #63a8be;
  z-index: 1000000;
  border-radius: 100px;
  background-color: #149dcc !important;
  border-color: #149dcc !important;
  color: #ffffff !important;
  font-weight: 500;
  border-width: 2px;
  font-style: normal;
  letter-spacing: 1px;
  margin: 0.4rem 0.8rem;
  white-space: normal;
  transition: all 0.3s ease-in-out;
  padding: 1rem 3rem;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  font-family: 'Rubik', sans-serif;
  font-size: 1rem;
  width: 30%;
}

.button-white {
  width: 30%;
  text-shadow:
    0 0 1px #5a7887,
    0 0 1px #63a8be;
  z-index: 1000000;
  cursor: pointer;
  border-radius: 100px;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #808080 !important;
  font-weight: 500;
  border-width: 2px;
  font-style: normal;
  letter-spacing: 1px;
  margin: 0.4rem 0.8rem;
  white-space: normal;
  transition: all 0.3s ease-in-out;
  padding: 1rem 3rem;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  font-family: 'Rubik', sans-serif;
  font-size: 1rem;
}

.button-blue:hover {
  color: #ffffff !important;
  background-color: #0d6786 !important;
  border-color: #0d6786 !important;
}

.button-white:hover,
.button-white:focus,
.button-white.focus,
.button-white.active {
  color: #ffffff !important;
  background-color: #0d6786 !important;
  border-color: #0d6786 !important;
}
`, "",{"version":3,"sources":["webpack://./src/terms/Terms.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,yDAAuD;;EAEvD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf;;mBAEiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;;mBAEiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EAGnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV;;mBAEiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EAGnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":["#root {\n  overflow: scroll;\n}\n.overlay {\n  /* height: 100%; */\n  height: 10000px;\n  background-color: #000;\n  bottom: 0;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: -1;\n  opacity: 0.8;\n  background-color: rgb(35, 35, 35);\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: center;\n  background-image: url('../images/tdl-home-middle.jpeg');\n\n  overflow: scroll;\n}\n\n.viewport {\n  height: 10000px;\n  overflow: scroll;\n  position: absolute;\n  top: 25vh;\n  left: 2vw;\n}\n\n.home-buttons-container {\n  margin-top: 600px;\n  margin-left: 25vw;\n}\n\n.overlay-middle {\n  top: 120px;\n  /* height: 100vh; */\n  padding-top: 90px;\n  padding-bottom: 90px;\n  background-color: #ffffff;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  word-wrap: break-word;\n  display: block;\n  box-sizing: border-box;\n}\n\n.home-top {\n  height: 100%;\n  padding-top: 80px;\n  padding-bottom: 0px;\n}\n\n@media only screen and (max-width: 800px) {\n  .overlay {\n    /* height: 600px; */\n  }\n  .home-top {\n    margin-top: 120px;\n    /* height: 350px; */\n    background-position: top 150px;\n  }\n  .home-buttons-container {\n    margin-top: 350px;\n    margin-left: 60px;\n  }\n  .home-main-text {\n    font-size: 26px;\n  }\n  .welcome-text {\n    font-size: 26px;\n  }\n  .welcome-sub-text-1 {\n    font-size: 26px;\n  }\n}\n\n.home-main-text {\n  padding: 10px;\n  margin-top: 45px;\n  margin-left: 25vw;\n}\n\n.welcome-text {\n  text-align: left;\n  color: white;\n  font-size: 100px;\n  text-shadow:\n    0 0 3px #5a7887,\n    0 0 5px #63a8be;\n}\n\n.welcome-sub-text-1 {\n  color: white;\n  font-size: 45px;\n  text-shadow:\n    0 0 3px #5a7887,\n    0 0 5px #63a8be;\n  /* border: #000; */\n}\n\n.button-blue {\n  text-shadow:\n    0 0 3px #5a7887,\n    0 0 5px #63a8be;\n  z-index: 1000000;\n  border-radius: 100px;\n  background-color: #149dcc !important;\n  border-color: #149dcc !important;\n  color: #ffffff !important;\n  font-weight: 500;\n  border-width: 2px;\n  font-style: normal;\n  letter-spacing: 1px;\n  margin: 0.4rem 0.8rem;\n  white-space: normal;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  padding: 1rem 3rem;\n  border-radius: 13px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  word-break: break-word;\n  font-family: 'Rubik', sans-serif;\n  font-size: 1rem;\n  width: 30%;\n}\n\n.button-white {\n  width: 30%;\n  text-shadow:\n    0 0 1px #5a7887,\n    0 0 1px #63a8be;\n  z-index: 1000000;\n  cursor: pointer;\n  border-radius: 100px;\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n  color: #808080 !important;\n  font-weight: 500;\n  border-width: 2px;\n  font-style: normal;\n  letter-spacing: 1px;\n  margin: 0.4rem 0.8rem;\n  white-space: normal;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  padding: 1rem 3rem;\n  border-radius: 13px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  word-break: break-word;\n  font-family: 'Rubik', sans-serif;\n  font-size: 1rem;\n}\n\n.button-blue:hover {\n  color: #ffffff !important;\n  background-color: #0d6786 !important;\n  border-color: #0d6786 !important;\n}\n\n.button-white:hover,\n.button-white:focus,\n.button-white.focus,\n.button-white.active {\n  color: #ffffff !important;\n  background-color: #0d6786 !important;\n  border-color: #0d6786 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
